module.exports = __webpack_public_path__ + "static/media/undraw_Bibliophile_hwqc.111c882d.png";